import React, {useMemo} from 'react';
import {ClientTable, TableColumn, Modal} from '@mc/ui-v4';
import {LogVO, UserLayersApi} from '../../api';
import {AttributesChangeModal} from '../forms/AttributesChangeModal';
import {LayerId} from '@mc/react-mapio';
import {useMapioContext} from '../../mapioContext';

type DataLogTableProps = {
    featureId: string;
    datalog: LogVO[];
    layerId: LayerId;
};

export const DataLogTable: React.FC<DataLogTableProps> = ({datalog, layerId, featureId}) => {
    const mapioContext = useMapioContext();
    const {context} = mapioContext.value;

    const columns: TableColumn<LogVO, {}>[] = useMemo(
        () => [
            {
                header: 'Datum',
                accessor: 'datum',
                width: '33%',
                type: 'dateTime',
            },
            {
                header: 'Pracovník',
                accessor: 'nazevPracovnika',
                width: '33%',
            },
            {
                header: 'Akce',
                accessor: 'nazevAkce',
                cell: ({row}) => <>{row.nazevAkce ?? 'Editace'}</>,
                width: '33%',
            },
        ],
        [],
    );

    const handleOpenAttsModal = async (row: LogVO) => {
        const logAtts = (await UserLayersApi.getAtributLog(Number(layerId), row.id, context)).data;
        const logDocs = (await UserLayersApi.getDokumentLog(Number(layerId), row.id, context)).data;
        Modal.show(({onClose}) => (
            <AttributesChangeModal title="Změna atributů" featureId={featureId} logAtts={logAtts} logDocs={logDocs} datalog={row} onClose={onClose} />
        ));
    };

    return (
        <ClientTable<LogVO>
            noVerticalScroll
            columns={columns}
            rows={datalog}
            sort={[{field: 'datum', asc: true}]}
            getRowProps={item => {
                return {
                    onClick: e => {
                        e.stopPropagation();
                        handleOpenAttsModal(item.row);
                    },
                };
            }}
        />
    );
};
